/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 7:51 AM
 *
 */

import { createSlice } from '@reduxjs/toolkit';

interface SideBarState {
  open: boolean;
}

const initialState: SideBarState = {
  open: false,
};

export const sideBarSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    toggleOpen: (state) => {
      state.open = !state.open;
    },
  },
});

export const { toggleOpen } = sideBarSlice.actions;

export default sideBarSlice.reducer;
